// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"796":"fb3c00cb","967":"032d257c"}[chunkId] + ".chunk.css";
};